import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ThemeContext from "./context/ThemeContext";
import store from "./store/store"; // Updated import
import { AuthProvider } from "./context/authContext";
import { LoaderProvider } from "./context/LoaderCotext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
        <BrowserRouter basename="/">
          <ThemeContext>
            <AuthProvider>
              <LoaderProvider>
              <App />
              </LoaderProvider>
            </AuthProvider>
          </ThemeContext>
        </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
